import { CaseHeader } from './case-header.model';
import { CaseLine } from './case-line.model';

export class Case extends CaseHeader {
  lines: CaseLine[];
}
